import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {BetLog, ListBetLogsResponse} from "../http/protocol";


export class SportsBetLogsService  extends AbstractAdminEntityService<BetLog, ListBetLogsResponse>  {

    constructor(http : HttpService) {
        super("/sportsbetting/bet-log", http)
    }

}